import plurilize from "pluralize-ru";
import { CodeTypes } from "./common";

export const getBytes = (kb: number) => kb * 1024;

export const fileFormatValidatorCreator = (formats: string[]) => {
  const loweredCaseFormats = formats.map((format) => format.toLowerCase());
  return (fileName: string) =>
    !loweredCaseFormats.includes(fileName.split(".").reverse()[0].toLowerCase());
};

export const innerErrors = {
  LIMIT: "Вы загрузили максимальное количество файлов.",
  LIMIT_EXCEEDED: "Файлы не добавлены. Вы выбрали больше файлов, чем можно.",
};

export const FILE_ERRORS = {
  [CodeTypes.VALIDATION_FAILED]: "Не подходит формат",
  [CodeTypes.SIZE_EXCEEDED]: "Не подходит размер",
  [CodeTypes.ERROR_INTERNAL]: "Не удалось загрузить",
};

const plurilizedFiles = (count: number) =>
  plurilize(count, "%d файлов", "%d файл", "%d файла", "%d файлов");
export const getNotificationText = {
  commonInfo: (loadedFilesCount: number, filesLength: number) =>
    `${loadedFilesCount && `Загружено ${plurilizedFiles(loadedFilesCount)}.`}
    ${
      filesLength - loadedFilesCount
        ? `Не удалось загрузить ${plurilizedFiles(filesLength - loadedFilesCount)}.`
        : ``
    }`,
  commonLoadingInfo: (filesCount: number) => `Загружается ${plurilizedFiles(filesCount)}.`,
  deleteText: (fileName: string) => `Файл удалён ${fileName}.`,
  cancelUploadText: (fileName: string) => `Загрузка отменена ${fileName}.`,
  tryAgainText: (fileName: string) => `Попытка повторной загрузки ${fileName}.`,
};
